// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__29Qml","buttons":"SendReceipts_buttons__SiYNL","email":"SendReceipts_email__2MT-V","bookApptTitle":"SendReceipts_bookApptTitle__1vWqN"};